import { window } from "global";
import React, { useEffect, useState } from "react";
import { Route, useLocation, useHistory } from "react-router-dom";
import classNames from "classnames";
import Masthead from "components/Masthead";
import MainContent from "components/MainContent";
import SideNav from "components/SideNav";
import { NotificationContainer } from "react-notifications";
import { CLASSES_FOR_URL } from "./lib/classes-and-specs";
import Banner from "./components/Common/Banner";
import { GameNav } from "@ugitgud/legos/components/nav/GameNav/GameNav";

const AppRouter = (props) => {
  const location = useLocation();
  const history = useHistory();
  const urlSegments = location.pathname.split("/");
  const [sideNavOpen, setSideNavOpen] = useState(false);
  const [autoSearch, setAutoSearch] = useState(false);

  useEffect(() => {
    // If the classname is in the spec position, need to swap class and spec and redirect to new page
    if (CLASSES_FOR_URL.includes(urlSegments[2]?.toLowerCase()) && window) {
      [urlSegments[2], urlSegments[3]] = [urlSegments[3], urlSegments[2]];
      history.replace(urlSegments.join("/"));
      window.location.reload();
    }

    // If the URL has "mythic" instead of "mythic+" - redirect
    // This works on both the tier list page and the talents pages
    if (urlSegments.length > 0 && urlSegments[urlSegments.length - 1].toLowerCase() === "mythic" && window) {
      urlSegments[urlSegments.length - 1] = "mythic+";
      history.replace(urlSegments.join("/"));
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    if (location.pathname !== location.pathname.toLowerCase() && window) {
      history.push(location.pathname.toLowerCase() + location.search);
    }
  }, [location.pathname]);

  let pageClassNames = classNames({
    dark: true,
    "desktop-container": true,
    "router-container": true,
    "no-masthead": false,
    "no-padding": location.pathname.match(/(^\/$)/) || location.pathname.match(/^\/support-us/g),
  });

  // TODO: Remove after Max page removed
  // Landing page
  if (
    location.pathname.match(/(^\/wow$)/) ||
    location.pathname.match(/(^\/wow\/$)/) ||
    location.pathname.match(/(^\/wow\/max$)/) ||
    location.pathname.match(/(^\/wow\/max\/$)/)
  ) {
    return (
      <div className={pageClassNames}>
        <GameNav selectedGame="wow" className="fixed top-0 left-0 z-[999]" />
        <Masthead isLandingPage sideNavOpen={sideNavOpen} setSideNavOpen={setSideNavOpen} setAutoSearch={setAutoSearch} />
        <SideNav open={sideNavOpen} setOpen={setSideNavOpen} />
        <div id="page-content">
          <div style={{ width: "100%" }}>
            <MainContent />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={pageClassNames}>
      <GameNav selectedGame="wow" className="fixed top-0 left-0 z-[999]" />
      <Masthead sideNavOpen={sideNavOpen} setSideNavOpen={setSideNavOpen} setAutoSearch={setAutoSearch} />
      <div id="page-content">
        <SideNav open={sideNavOpen} setOpen={setSideNavOpen} autoSearch={autoSearch} setAutoSearch={setAutoSearch} />
        <div style={{ width: "100%" }}>
          <MainContent sideNavOpen={sideNavOpen} />
        </div>
      </div>
      <Route path="/" />
      <NotificationContainer />
    </div>
  );
};

export default AppRouter;
